import React, { Component } from "react";

import { TextField, Box, FormControl, InputLabel, Select, FormHelperText, OutlinedInput, InputAdornment, Checkbox, Autocomplete } from '@mui/material';
import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";

class InputText extends Component{

    render(){
        const { 
            name,
            value,
            error,
            change,
            onChange,
            title,
            placeholder,
            disabled,
            required,
            label,
            helperText,
            min,
            max,
            step,
            type,
            size,
            variant,
            rows,
            multiline,
            endAction,
            startAdornment
          } = this.props
        
        return(     
            <Box p={1} >       
                <TextField
                    name={name} 
                    size={size} 
                    min={min} 
                    max={max} 
                    step={step} 
                    id={name} 
                    value={value} 
                    label={label || placeholder} 
                    placeholder={placeholder || label}
                    onChange={ onChange || change } 
                    error={!!error} 
                    helperText={error || helperText} 
                    type={type || "text"}
                    required={required}
                    disabled={disabled}
                    style={{ width:"100%" }}
                    variant={variant || "outlined"}  
                    multiline={multiline}  
                    minRows={rows}  
                    InputProps={{ 
                      endAdornment: <InputAdornment position="end">{endAction}</InputAdornment>,
                      startAdornment: startAdornment
                    }}
                />
            </Box>
        )
    }           
}

export default InputText;

export class InputSelect extends Component{
                    
  render(){
      const { 
          name,
          value,
          onChange,
          title,
          disabled,
          required,
          options,
          isMulti,
          placeholder,
          label,
          error,
          helperText
      } = this.props
      let idValue = typeof value === 'string' ? value : value.value
      console.log({idValue}, typeof value, value);
      let OPTION = {value:"", label: ""}
      return (
        <Box p={1} >    
            <FormControl variant="outlined" style={{width: "100%"}} error={!!error} required={required}>
              {/* <InputLabel htmlFor={name}>{label}</InputLabel> */}
              <Autocomplete
                  value={value}                    
                  placeholder={placeholder}
                  options={options}
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option) => option.value === value.value}
                  getOptionDisabled={(option) => option.disabled}
                  onChange={(e, option) => onChange(option || OPTION, option ? option.value : "")}
                  required={required}
                  disabled={disabled}
                  multiple={isMulti}
                  PopperProps={{
                      style: { zIndex: 13002 },
                      sx: { zIndex: 13002 }
                  }}
                  ListboxProps={{
                      style: { zIndex: 13002 }
                  }}
                  componentsProps={{
                      popper: {
                          style: { zIndex: 13002 },
                          sx: { zIndex: 13002 }
                      }
                  }}
                  // inputProps={{
                  //   name: name,
                  //   id: name,
                  // }}
                  renderInput={(params) => <TextField variant="outlined" {...params} label={label || title} name={name} id={name} />}
              />    
              <FormHelperText>{error || helperText}</FormHelperText>
            </FormControl>          
        </Box>
      );
  }           
}
const icon = <CheckBoxOutlineBlank fontSize="small" />;
const checkedIcon = <CheckBox fontSize="small" />;
export class InputSelectMulti extends Component{
                    
  render(){
      const { 
          name,
          value,
          onChange,
          title,
          disabled,
          required,
          options,
          isMulti,
          placeholder,
          label,
          error,
          helperText,
          withCheckBox
      } = this.props
      
      return (
        <Box p={1} >    
            <FormControl variant="outlined" style={{width: "100%"}} error={!!error} required={required}>
              {/* <InputLabel htmlFor={name}>{label}</InputLabel> */}
              <Autocomplete
                  placeholder={placeholder}
                  options={options}
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option) => option.value === value}
                  getOptionDisabled={(option) => option.disabled}
                  onChange={(e, option) => onChange(option, option.value)}
                  required={required}
                  disabled={disabled}
                  multiple={true}
                  disableCloseOnSelect={true}
                  PopperProps={{
                      style: { zIndex: 13002 },
                      sx: { zIndex: 13002 }
                  }}
                  ListboxProps={{
                      style: { zIndex: 13002 }
                  }}
                  componentsProps={{
                      popper: {
                          style: { zIndex: 13002 },
                          sx: { zIndex: 13002 }
                      }
                  }}
                  // inputProps={{
                  //   name: name,
                  //   id: name,
                  // }}
                  renderInput={(params) => <TextField variant="outlined" {...params} label={label || title} name={name} id={name} />}
                  renderOption={(props, option) => (
                    <li {...props}>
                      {withCheckBox &&
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={option.disabled}
                        />}
                      {option.label}
                    </li>
                  )}
              />    
              <FormHelperText>{error || helperText}</FormHelperText>
            </FormControl>
                      
        </Box>
      );
  }           
}
export class InputSelectMultiV2 extends Component{
                    
  render(){
      const { 
          name,
          value,
          onChange,
          title,
          disabled,
          required,
          options,
          isMulti,
          placeholder,
          label,
          error,
          helperText,
          withCheckBox
      } = this.props
      
      
      // onChange={(e, option) => onChange(option || OPTION, option ? option.value : "")}

      return (
        <Box p={1} >    
            <FormControl variant="outlined" style={{width: "100%"}} error={!!error} required={required}>
              {/* <InputLabel htmlFor={name}>{label}</InputLabel> */}
              <Autocomplete
                  value={value}                    
                  placeholder={placeholder}
                  options={options}
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option) => option.value === value}
                  getOptionDisabled={(option) => option.disabled}
                  onChange={(e, option) => onChange(option, option.value)}
                  required={required}
                  disabled={disabled}
                  multiple={true}
                  disableCloseOnSelect={true}
                  PopperProps={{
                      style: { zIndex: 13002 },
                      sx: { zIndex: 13002 }
                  }}
                  ListboxProps={{
                      style: { zIndex: 13002 }
                  }}
                  componentsProps={{
                      popper: {
                          style: { zIndex: 13002 },
                          sx: { zIndex: 13002 }
                      }
                  }}
                  // inputProps={{
                  //   name: name,
                  //   id: name,
                  // }}
                  renderInput={(params) => <TextField variant="outlined" {...params} label={label || title} name={name} id={name} error={error}/>}
                  renderOption={(props, option) => (
                    <li {...props}>
                      {withCheckBox &&
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={option.disabled}
                        />}
                      {option.label}
                    </li>
                  )}
              />    
              <FormHelperText>{error || helperText}</FormHelperText>
            </FormControl>
                      
        </Box>
      );
  }           
}
export class InputSelectNative extends Component{
                    
    render(){
        const { 
            name,
            value,
            onChange,
            change,
            title,
            disabled,
            required,
            options,
            isMulti,
            placeholder,
            label,
            error,
            helperText,
            helperText2,
            labelWidth,  
        } = this.props
        
        return(     
            <Box p={1} >      
                <FormControl variant="outlined" style={{width: "100%"}} error={!!error} required={required}>
                    <InputLabel htmlFor={name}>{label || title}</InputLabel>
                    <Select
                        native
                        onChange={onChange || change}
                        value={value}
                        disabled={disabled}
                        // input={<OutlinedInput labelWidth={labelWidth || 100} name={name} id={name} />}
                        // required={required}
                        // error={!!error} 
                        inputProps={{
                          name: name,
                          id: name,
                        }}
                        label={label || title}
                    >
                        <option value="" />
                        {options}
                    </Select>
                    <FormHelperText>{error || helperText}</FormHelperText>
                    <FormHelperText>{helperText2}</FormHelperText>
                </FormControl>                
            </Box>
        )
    }           
}

export class TextArea extends Component{
                   
    render(){
        const { 
            name,
            value,
            error,
            change,
            onChange,
            title,
            placeholder,
            disabled,
            label,
            required,
            rows  } = this.props
        
        return(
            <Box p={1} >
                <TextField
                    // margin="normal"
                    type="text"
                    name={name} 
                    id={name} 
                    value={value} 
                    label={label || title} 
                    placeholder={placeholder || title}
                    onChange={ onChange || change } 
                    error={!!error} 
                    helperText={error} 
                    required={required}
                    disabled={disabled}
                    rows={rows || 3}
                    multiline
                    style={{ width:"100%" }}
                    variant="outlined"  
                />
            </Box>
        )
    }           
}

export class Photos extends React.Component {
    state = {
      files:this.props.photos,
      max: this.props.max || 1,
    }
  
    onRemoveImage= async (e, index) => {
      e.preventDefault();
      
      this.setState({
        ...this.state,
        files:[
          ...this.state.files.slice(0,index), 
          ...this.state.files.slice(index+1)
        ]
      });
      this.props.photoList(this.state.files)// send photoList to Products component
    }
  
    handleAddImage= async (e) =>{
      e.preventDefault();
      let exist = this.state.files.length;
      let list = e.target.files;
  
      console.log("[INFO], Upload Image list", list);
  
      let max = (exist + list.length) > this.state.max ? (this.state.max - exist) : list.length// 4 pics max
  
      for (let i = 0; i < max; i++) {
        let reader = new FileReader();
        let file = list[i];
  
        reader.onloadend = async (upload) => {
          console.log("[INFO]onloadend upload reader ",i, reader);
  
          this.setState({ 
            ...this.state,  
            files:[
              ...this.state.files, 
              { 
                "data_uri": upload.target.result, 
                "file": file, 
                "filename": file.name,
                "filetype": file.type,
                "UploadButtonStatus": '', 
                "imageStatus": 'fileinput fileinput-exists'
              }
            ]
          })
          this.props.photoList(this.state.files) // send photoList to Products component
        }
        await reader.readAsDataURL(file)// ??
      }
      
    }
    handleChange(e, index) {
      e.preventDefault();
      console.log("[INFO], Upload One Image", index);
  
      let reader = new FileReader();
      let file = e.target.files[0];
  
      reader.onloadend = (upload) => {
        
        this.setState({
          ...this.state,
          files:[
            ...this.state.files.slice(0,index),
            {
              "data_uri": upload.target.result, 
              "file": file, 
              "filename": file.name,
              "filetype": file.type,
              "UploadButtonStatus": '', 
              "imageStatus": 'fileinput fileinput-exists'
            },
            ...this.state.files.slice(index+1),
          ]
        });
        this.props.photoList(this.state.files) // send photoList to Products component
      }
  
      reader.readAsDataURL(file)
      
    }
  
    displayPhotos = () =>{
      // console.log("[INFO], DISPLAY PHOTOS ");
      
      if( this.state.files.length > 0 ){
  
        return this.state.files.map((file, i) => {
          return (
            <div key={i} className={file.imageStatus} data-provides="fileinput">
              <div className="fileinput-preview thumbnail" data-trigger="fileinput">
                <img src={file.data_uri}/>
              </div>
              <div>
                <span className="btn btn-info btn-file waves-effect">
                  <span className="fileinput-exists">Change</span>
                  <input type="file" name="File" onChange={(e) => this.handleChange(e, i)}/>
                </span>
                <a
                  className="btn btn-danger fileinput-exists waves-effect"
                  data-dismiss="fileinput"
                  onClick={(e) => this.onRemoveImage(e, i)}>Remove</a>
              </div>
            </div>
          )
        })
      }
          
    }
  
  
    render() {
      // console.log("[STATE] FILES", this.state.files);
      
      return (
        <div className="">
        {this.state.files.length < this.state.max &&
          <span className="btn btn-info btn-file waves-effect">
            <span className="fileinput-new">+</span>
            <input type="file" 
              multiple 
              name="..." 
              onChange={(e) => {this.handleAddImage(e) }
                }/>
          </span>
        }
          <div>
            {this.displayPhotos()}
          </div>
  
        </div>
      )
    }
  }